export const webCache = new Map();
export const generalCache = new Map();
